import React from 'react';
import PhoneNumberInput from 'apollo-react/components/PhoneNumberInput';
import './common.css';

const PhoneInput = ({
  field,
  meta,
  label,
  onChange,
  value,
  required,
  fullWidth = true,
  style,
}) => {
  return (
    <PhoneNumberInput
      {...field}
      label={label}
      defaultCountry="eg"
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : ''}
      onChange={(value) => onChange(value)}
      fullWidth={fullWidth}
      required={required}
      value={value}
      style={style}
    />
  );
};

export default PhoneInput;
